import React from 'react';
import { CopyToClipboard, Textarea } from '@cloudscape-design/components';
import styles from './LetterEditor.module.css';

export default function LetterEditor({ label, value = '', onChange, readOnly = false, rows = 18 }) {
  return (
    <div className={styles.editor}>
      <Textarea
        className={styles.textarea}
        ariaLabel={label}
        value={value}
        onChange={onChange}
        readOnly={readOnly}
        rows={rows}
        spellcheck={true}
      />
      {value.trim() && (
        <div className={styles.copy}>
          <CopyToClipboard
            variant="icon"
            textToCopy={value}
            copyButtonAriaLabel={`Copy ${label.toLowerCase()} to clipboard`}
            copySuccessText="Letter copied"
            copyErrorText="Unable to copy. Select the letter text and copy it manually."
            popoverRenderWithPortal
          />
        </div>
      )}
    </div>
  );
}
